function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function asString(value) {
  return typeof value === 'string' ? value : '';
}

export default function CoachInteractionAdapter(response) {
  const entries = asArray(response?.entries).map((entry) => {
    return {
      ...entry,
      id: asString(entry?.id).trim(),
      delivery: asString(entry?.delivery).trim(),
      trigger: entry?.trigger && typeof entry.trigger === 'object' ? entry.trigger : {},
      raw: entry,
    };
  });

  return {
    ok: response?.ok === true,
    assistant: response?.assistant || {},
    interaction: response?.interaction || {},
    entries,
    debug: response?.debug || {},
  };
}
